'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Animator = /** @class */ (function () {
    function Animator(canvas) {
        this.running = false;
        this.frameId = 0;
        this.lastFrame = 0;
        this.delta = 0;
        this.fps = 0;
        this._showFps = false;
        this._autoStopped = false;
        this._fpsColor = '#000';
        this._eachFrame = function () { };
        if (typeof canvas === 'string') {
            var element = document.querySelector(canvas);
            if (!element)
                throw new Error("Cannot find canvas with selector '" + canvas + "'");
            canvas = element;
        }
        this.canvas = canvas;
        this.ctx = this.canvas.getContext('2d');
        this.resizeCanvas();
        document.addEventListener('visibilitychange', this.autoStop.bind(this));
    }
    Animator.prototype.start = function () {
        if (this.running)
            return this;
        this.running = true;
        this.lastFrame = performance.now();
        this.requestNewFrame();
        return this;
    };
    Animator.prototype.stop = function () {
        if (!this.running)
            return this;
        cancelAnimationFrame(this.frameId);
        this.running = false;
        this.frameId = 0;
        return this;
    };
    Animator.prototype.toggle = function () {
        return this.running ? this.stop() : this.start();
    };
    Animator.prototype.eachFrame = function (callback) {
        this._eachFrame = callback;
        return this;
    };
    Animator.prototype.showFps = function (color) {
        this._showFps = true;
        if (color)
            this._fpsColor = color;
        return this;
    };
    Animator.prototype.resizeCanvas = function () {
        this.canvas.width = this.canvas.clientWidth;
        this.canvas.height = this.canvas.clientHeight;
    };
    Animator.prototype.frame = function (ts) {
        this.fps = 1000 / (ts - this.lastFrame);
        this.delta = 1 / this.fps;
        this.requestNewFrame();
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this._eachFrame(this.ctx, this.delta);
        if (this._showFps) {
            var oldColor = this.ctx.fillStyle;
            this.ctx.fillStyle = this._fpsColor;
            this.ctx.fillText("" + Math.round(this.fps), 10, 20);
            this.ctx.fillStyle = oldColor;
        }
        this.lastFrame = ts;
    };
    Animator.prototype.requestNewFrame = function () {
        this.frameId = requestAnimationFrame(this.frame.bind(this));
    };
    Animator.prototype.autoStop = function () {
        if (!this.running && !this._autoStopped)
            return;
        this._autoStopped = this.running;
        this.toggle();
    };
    return Animator;
}());

var animate = function (canvas) { return new Animator(canvas); };

exports.animate = animate;
exports.default = Animator;
